import React from 'react'

import { RouteComponentProps } from 'react-router'
import { parse } from 'query-string'

import { ResultContextProvider } from 'src/context/results'
import { ResultsList, ResultsHeader } from 'src/refactor/blocks'
import { SearchParams } from 'src/api/types'
import { MapProvider } from 'react-map-gl'

export const Results: React.FC<RouteComponentProps> = ({ location }) => {
  const initialParams = parse(location.search) as Record<
    keyof SearchParams,
    string | string[]
  >

  return (
    <ResultContextProvider initialParams={initialParams}>
      <MapProvider>
        <ResultsHeader />
        <ResultsList />
      </MapProvider>
    </ResultContextProvider>
  )
}
